import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';
import { repeatTransaction } from '../utils/CommonFunctions';
import { toast } from 'react-toastify';

const TransactionDetailView = () => {
  const { state } = useLocation();
  const txn = state?.txn;
  console.log('Transaction', txn);
  const navigate = useNavigate();
  const [buttonLoading, setButtonLoading] = useState(false);
  const [, setcurrencyCloudBalance] = useState(null);
  const [, setclearBankBalance] = useState(null);
  const [, setclearBankConfiguration] = useState(null);
  const currencyid = txn?.currencyid || 231;
  const showRepeatButton = txn?.status?.toLowerCase() === 'settled';

  console.log('txn', txn);

  if (!txn) {
    return (
      <div className="min-h-screen bg-[#F5F7FA] flex items-center justify-center">
        <div className="text-center">
          <p className="text-gray-500 mb-4">No transaction data found.</p>
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="text-[#1E2A3B] font-semibold hover:opacity-70"
          >
            ← Go Back
          </button>
        </div>
      </div>
    );
  }

  const isCompleted = (status) => {
    if (!status) return false;
    const s = status.toLowerCase();
    return s === 'completed' || s === 'complete';
  };

  const completed = isCompleted(txn?.status);

  const formattedDate = new Date(txn.date).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });

  const formattedDateTime = new Date(txn.date).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });

  const handleBack = () => navigate(-1);

  const handleRepeat = () => {
    repeatTransaction({
      txn,

      currencyid,
      navigate,
      setButtonLoading,
      setcurrencyCloudBalance,
      setclearBankBalance,
      setclearBankConfiguration,
      toast,
    });
  };

  const detailRows = [
    { label: 'Transaction ID', value: txn?.id || 'N/A' },
    { label: 'Type of transaction', value: 'Debit', bold: true },
    {
      label: 'Sent Amount',
      value: `₹ ${Number(txn.amount).toLocaleString()}`,
      bold: true,
    },
    { label: 'Date & Time', value: formattedDateTime, bold: true },
    { label: 'Currency', value: txn.currency, bold: true },
    {
      label: 'Status',
      value: completed ? 'Completed' : txn?.status || 'Pending',
      bold: true,
      color: completed ? 'text-[#1E2A3B]' : 'text-orange-500',
    },
    {
      label: 'Transfer Reason',
      value: txn?.meta_data?.reason || 'N/A',
      bold: true,
    },
  ];

  const beneficiaryRows = [
    {
      label: 'Account Name',
      value: txn?.beneficiary?.accountName || txn?.name || 'N/A',
    },
    {
      label: 'Account Number',
      value: txn?.meta_data?.second_beneficiary_bank_account_number || 'N/A',
    },
    {
      label: 'Code',
      value: txn?.meta_data?.second_beneficiary_bank_code || '-',
    },
  ];

  return (
    <div className="min-h-screen bg-[#F5F7FA]">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 px-6 py-4 text-center">
        <h1 className="text-xl font-bold text-[#1E2A3B]">
          Transaction View Details
        </h1>
      </div>

      <div className="max-w-2xl mx-auto px-4 py-6">
        {/* Back Button */}
        <button
          type="button"
          onClick={handleBack}
          className="flex items-center gap-2 text-[#1E2A3B] font-semibold mb-6 hover:opacity-70 transition-opacity"
        >
          <span className="text-lg">←</span> Back
        </button>

        {/* Main Card */}
        <div className="bg-white rounded-2xl shadow-sm overflow-hidden">
          {/* Recipient Header */}
          <div className="px-6 pt-6 pb-4 flex items-center gap-4">
            <div className="w-12 h-12 rounded-full bg-gray-500 flex items-center justify-center text-white font-bold text-lg flex-shrink-0">
              {txn.name?.[0]?.toUpperCase()}
            </div>
            <div>
              <div className="flex items-center gap-2">
                <span className="font-bold text-[#1E2A3B] text-base">
                  {txn.name}
                </span>
                {txn.flag && <span className="text-lg">{txn.flag}</span>}
              </div>
              <p className="text-sm text-gray-500">Sent On : {formattedDate}</p>
            </div>
          </div>

          {/* Transaction Details */}
          <div className="mx-6 mb-4 border border-gray-100 rounded-xl p-4">
            <h3 className="font-bold text-[#1E2A3B] mb-3">
              Transaction Details
            </h3>
            <div className="space-y-3">
              {detailRows.map(({ label, value, bold, color }) => (
                <div key={label} className="flex justify-between text-sm">
                  <span className="text-gray-500">{label}</span>
                  <span
                    className={`${bold ? 'font-bold' : ''} text-[#1E2A3B] ${color || ''}`}
                  >
                    {value}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Beneficiary Details */}
          <div className="mx-6 mb-4 border border-gray-100 rounded-xl p-4">
            <h3 className="font-bold text-[#1E2A3B] mb-3">
              Beneficiary Details
            </h3>
            <div className="space-y-3">
              {beneficiaryRows.map(({ label, value }) => (
                <div key={label} className="flex justify-between text-sm">
                  <span className="text-gray-500">{label}</span>
                  <span className="font-bold text-[#1E2A3B]">{value}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Notes & Attachments */}
          {/* <div className="mx-6 mb-6 border border-gray-100 rounded-xl p-4">
            <button
              type="button"
              onClick={() => setNotesOpen((prev) => !prev)}
              className="w-full flex items-center justify-between text-blue-600 font-semibold"
            >
              <span>Notes &amp; Attachments</span>
              <span
                className="transition-transform duration-200 text-blue-600 inline-block"
                style={{ transform: notesOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}
              >
                ▾
              </span>
            </button>
            {notesOpen && (
              <p className="mt-3 text-sm text-gray-400">No notes or attachments added.</p>
            )}
          </div> */}
        </div>

        {/* Repeat Again Button */}
        {showRepeatButton && (
          <button
            type="button"
            onClick={handleRepeat}
            disabled={buttonLoading}
            className="w-full mt-5 py-4 rounded-2xl text-white font-bold text-lg flex items-center justify-center gap-3 transition-all duration-200 hover:opacity-90 active:scale-95 disabled:opacity-60 disabled:cursor-not-allowed"
            style={{ backgroundColor: '#E8650A' }}
          >
            {buttonLoading ? 'Loading...' : 'Repeat Again'} <span>↗</span>
          </button>
        )}

        <div className="mt-4 bg-orange-50 rounded-2xl p-4 flex gap-3 items-start">
          <span className="text-orange-400 text-lg mt-0.5">🔒</span>
          <div>
            <p className="font-bold text-[#1E2A3B] text-sm">
              100% Secure &amp; Safe
            </p>
            <p className="text-xs text-gray-500 mt-1">
              Your money is protected with bank-level encryption. We never store
              your banking credentials.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

TransactionDetailView.propTypes = {
  onRepeat: PropTypes.func.isRequired,
  buttonLoading: PropTypes.bool,
};

TransactionDetailView.defaultProps = {
  buttonLoading: false,
};

export default TransactionDetailView;
